document.addEventListener("DOMContentLoaded", () => {
	initAddToCartForm();

	$.nette.ext("add-to-cart-form", {
		success: function () {
			initAddToCartForm();
		}
	});
});

function initAddToCartForm() {
	const inputSelector = ".add-to-cart-input";

	$(".add-to-cart-plus").off("click").on("click", function (e) {
		const inputElem = $(this).parents(".form-inline-product-add-to-cart").find(inputSelector);
		const currentVal = parseInt(inputElem.val());

		if (currentVal < inputElem.attr("max")) {
			inputElem.val(currentVal + 1);
		}

		e.preventDefault();
		e.stopPropagation();
	});

	$(".add-to-cart-minus").off("click").on("click", function (e) {
		const inputElem = $(this).parents(".form-inline-product-add-to-cart").find(inputSelector);
		const currentVal = parseInt(inputElem.val());

		if (currentVal > inputElem.attr("min")) {
			inputElem.val(currentVal - 1);
		}

		e.preventDefault();
		e.stopPropagation();
	});
}
